import { api } from './client'
import type { ValueTag } from '@/types'

export function fetchValueTags(): Promise<ValueTag[]> {
  return api.get('/api/value-tags')
}

export function fetchValueTagsWithCounts(): Promise<{ tag: ValueTag; count: number }[]> {
  return api.get('/api/value-tags/with-counts')
}

export function fetchTagsForPriority(priorityId: string): Promise<ValueTag[]> {
  return api.get(`/api/value-tags/for-priority/${priorityId}`)
}

export async function createValueTag(label: string): Promise<string> {
  const { id } = await api.post<{ id: string }>('/api/value-tags', { label })
  return id
}

export function deleteValueTag(id: string): Promise<void> {
  return api.delete(`/api/value-tags/${id}`)
}

export function addTagToPriority(priorityId: string, tagId: string): Promise<void> {
  return api.post(`/api/value-tags/${tagId}/assign`, { priorityId })
}

export function removeTagFromPriority(priorityId: string, tagId: string): Promise<void> {
  return api.delete(`/api/value-tags/${tagId}/assign/${priorityId}`)
}

export async function createAndAssignTag(priorityId: string, label: string): Promise<string> {
  const { id } = await api.post<{ id: string }>('/api/value-tags/assign-new', { priorityId, label })
  return id
}

export function renameValueTag(id: string, label: string): Promise<void> {
  return api.patch(`/api/value-tags/${id}`, { label })
}
